export const PRIMARY_LANGUAGE_OPTIONS = [
  { value: 'English', label: 'English' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'French', label: 'French' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Mandarin', label: 'Mandarin' },
  { value: 'Japanese', label: 'Japanese' },
] as const;

export const CLIENT_SEX_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
] as const;

// Required-field validation messages follow the "<Field> is required" convention. Shared form fields
// use this suffix to detect (and suppress) the redundant required message on an empty field while
// still surfacing any other validation message.
export const REQUIRED_FIELD_ERROR_SUFFIX = 'is required';

// TODO(referral-api): replace with backend-provided canonical lists.
export const DIAGNOSTIC_ASSESSMENT_OPTIONS = [
  { value: 'ADOS-2', label: 'ADOS-2 (Autism Diagnostic Observation Schedule)' },
  { value: 'ASRS', label: 'Autism Spectrum Rating Scales (ASRS)' },
  { value: 'AQ', label: 'AQ (Autism Spectrum Quotient)' },
  { value: 'CARS-2', label: 'CARS-2 (Childhood Autism Rating Scale)' },
  { value: 'GARS-2', label: 'GARS-2 (Gilliam Autism Rating Scale)' },
  { value: 'M-CHAT-R/F', label: 'M-CHAT-R/F (Modified Checklist for Autism in Toddlers)' },
  { value: 'PEDS', label: "Parents' evaluation of Developmental Status (PEDS)" },
  { value: 'SRS-2', label: 'SRS-2 (Social Responsiveness Scale)' },
  { value: 'STAT', label: 'STAT (Screening Tool for Autism in Toddlers)' },
  { value: 'Tele-ASD-Peds', label: 'Tele-ASD-Peds' },
  { value: 'Other', label: 'Other' },
] as const;

export const INTAKE_INTRODUCTION_VIDEO_SRC = 'https://stream.mux.com/1zKqblxJHNPKLXqArChYsOp21Q2yZRs2Bld1WTf01HFk.m3u8';
export const INTAKE_INTRODUCTION_VIDEO_POSTER =
  'https://image.mux.com/1zKqblxJHNPKLXqArChYsOp21Q2yZRs2Bld1WTf01HFk/thumbnail.webp?time=11&width=1200';
export const ONBOARDING_INTRODUCTION_VIDEO_SRC = 'https://stream.mux.com/UpX01FDnaIzluk018AWW36Cw26k4dx302McTDkIlO7yuLA.m3u8';
export const ONBOARDING_INTRODUCTION_VIDEO_POSTER =
  'https://image.mux.com/UpX01FDnaIzluk018AWW36Cw26k4dx302McTDkIlO7yuLA/thumbnail.webp?time=11.5&width=1200';
